import 'rss-parser/dist/rss-parser.js';

import foodsapp from "../assets/img/projects/foodsapp/foodsapp.jpg"

import gripit from "../assets/img/projects/gripit/gripit.jpg"
import gripit1 from "../assets/img/projects/gripit/gripit2.jpg"
import gripit2 from "../assets/img/projects/gripit/gripit_ios.jpg"
import gripit3 from "../assets/img/projects/gripit/gripit_trainings.jpg"

import velocicaptor from "../assets/img/projects/velocicaptor/velocicaptor.jpg"
import humane_robotics from "../assets/img/projects/humane_robotics/humane_robotics.jpg"

import mcevr from "../assets/img/projects/polidea/mcevr.jpg";
import mcevr1 from "../assets/img/projects/polidea/mce_vr_kris2.jpg";

import smarthop from "../assets/img/projects/polidea/smartshop.jpg";
import smarthop1 from "../assets/img/projects/polidea/smartshop_1.jpg";

import webvr from "../assets/img/projects/polidea/webvr.jpg";
import webvr1 from "../assets/img/projects/polidea/webvr1.jpg";
import webvr2 from "../assets/img/projects/polidea/webvr2.jpg";


const parser = new window.RSSParser();

export const Dictionary = {
    name: "Krzysztof (Chris) Wróbel",
    role: "Entrepreneur, Developer, Speaker",
    bio: "Chris is a Virtual and Augmented Reality expert and evangelist, currently freelancing as consultant and developer " +
    "for VR, AR, and Machine learning projects. In the past two years, helping other IT companies embrace new technologies (VR/AR), and with growth strategies.\n" +
    "In the past, he gained business experience co-founding tech startups, like Gripit, VelociCaptor or Foodsapp. In his free time, he is a dedicated climber.",
    entrepreneur: "I've gained business experience co-founding tech startups, like Gripit, VelociCaptor or Foodsapp. " +
    "I've learnt how to develop and evaluate business ideas with Lean Methodology. " +
    "I spent numerous hours revising Business Strategies, pitching, negotiating with investors, design and developing products. " +
    "This gave me enough experience to advise others on Growth Strategy and in the prcoess I've become a Product Owner.",
    developer: "Deep down a Software engineer with a 7 years experience, who dived into many various development technologies for Mobile, Web, VR, AR and Datascience.",
    speaker: "I believe that only by working together with keen and ambitious minds, we are able to create truly impactful and disruptive solutions. " +
    "Since I'm being inspired by many great minds, I've decided to also share my business and technological experience with a community.",
    programming_languages: "Java, C#, Python, R, Javascript",
    vrar_skills: "Unity, ARKit, ARCore, WebVR",
    datascience_skills: "Tensorflow, Scrappy, SciPy, OpenCV",
    mobile_skills: "Android, RXJava, Retrofit",
    front_backend_skills: "React, Firebase, Django, Flusk, REST",
    other_skills: "Product Ownership, Business Development, Team Building, Accounting, Scrum",
    twitter: "https://twitter.com/chwro",
    linkedin: "https://linkedin.com/in/chris-wrobel",
    instagram: "https://www.instagram.com/chwro",
    blog: "https://vrational.com",
    email: "me@chriswrobel.com"
};

export const Tags = {
    ANDROID: {
        name: "Android",
        color: "#4caf50"
    },
    IOS: {
        name: "iOS",
        color: "#ffc11a"
    },
    STARTUP: {
        name: "Startup",
        color: "#212caa"
    },
    IOT: {
        name: "IoT",
        color: "#f44336"
    },
    ML: {
        name: "ML",
        color: "#9c27b0"
    },
    PYTHON: {
        name: "Python",
        color: "#318daa"
    },
    UNITY: {
        name: "Unity",
        color: "#aa7208"
    },
    AR: {
        name: "AR",
        color: "#170457"
    },
    VR: {
        name: "VR",
        color: "#3e0aaa"
    },
    WEB: {
        name: "Web",
        color: "#903803"
    },
};
export const Speaking = [
        {
            year: 2018,
            items: [
                {
                    date: "15th November",
                    place: "Futureland 2018, Milan, Italy",
                    topic: "Teaching robots to imitate a human movements with Machine Learning and VR",
                    slides: "",
                    video: "",
                    link: "https://www.futureland.co/"
                },
                {
                    date: "27th October",
                    place: "GDG Devfest 2018, Wroclaw, Poland",
                    topic: "Creating spontaneous AR interactions with Google ARCore and Instant Apps",
                    slides: "",
                    video: "",
                    link: "https://wroclaw.devfest.pl/speakers/krzysztof_wrobel/"
                },
                {
                    date: "18th October",
                    place: "AWE EU 2018, Munich, Germany",
                    topic: "VR and Imitation Machine Learning algorithms for training robots",
                    slides: "",
                    video: "https://www.youtube.com/watch?v=aS_w668fzX8&list=PLLri17oDqCEX0QOZ2gmu997I7sQC_cWJg&index=4&t=3s",
                    link: "https://eu.augmentedworldexpo.com/sessions/develop-session-6/"
                },
                {
                    date: "27th September",
                    place: "Digility 2018, Cologne, Germany",
                    topic: "Using VR and Imitation Machine Learning algorithms for training robots",
                    slides: "",
                    video: "",
                    link: "https://www.digility.de/conference/speakers-2018/detail/?tx_femanager_pi1%5Baction%5D=show&tx_femanager_pi1%5Bcontroller%5D=User&tx_femanager_pi1%5Buser%5D=10931"
                },
                {
                    date: "25th June",
                    place: "Founders Institute Warsaw",
                    topic: "Does VR/AR solve the biggest problems of the humanity?",
                    slides: "",
                    video: "",
                    link: "https://fi.co/event/frontier-founders-forum-solving-the-biggest-problems-of-humanity-3480b69d-7db4-4de4-9a41-431ffa973fda"
                },
                {
                    date: "5th June",
                    place: "Logistics & Production. Future 2 to 5",
                    topic: "7 ways of using VR/AR in logistics",
                    slides: "",
                    video: "",
                    link: "http://bluevine.pl/konferencja/logistyka-produkcja-future-2-to-5/"
                },
                {
                    date: "24th May",
                    place: "Logistics 2018 by Polish Logistics Congress",
                    topic: "VR/AR innovations in a warehouse management and logistics",
                    slides: "",
                    video: "",
                    link: "https://www.logistics.pl/program/sesje-tematyczne-2018/sesja-b3-magazyn-4-0-nowoczesne-centra-magazynowe"
                },
                {
                    date: "22nd May",
                    place: "Digital Poland foundation board meeting",
                    topic: "7 ways VR/AR is used in a traditional business. How to innovate with it in yours",
                    slides: "",
                    video: "",
                    link: "https://www.digitalpoland.org/"
                },
                {
                    date: "27th March",
                    place: "Logistics. Investments. Future 2 to 5",
                    topic: "7 ways of using VR/AR in logistics",
                    slides: "",
                    video: "",
                    link: "http://bluevine.pl/konferencja/logistyka-inwestycje-przyszlosc-2/"
                },
                {
                    date: "27th March",
                    place: "Warsaw IT days",
                    topic: "How to make AR game in 48 hours",
                    slides: "",
                    video: "",
                    link: "https://warszawskiedniinformatyki.pl/en/"
                },
            ]
        },
        {
            year: 2017,
            items:
                [
                    {
                        date: "9th December",
                        place: "DevFest Poland 2017",
                        topic: "AR game in 48 hours",
                        slides: "",
                        video: "",
                        link: "https://devfest.pl/speakers/27/"
                    },
                    {
                        date: "23rd January",
                        place: "GDG VR Warszawa",
                        topic: "Mobile VR - why no one is taking it seriously?!",
                        slides: "",
                        video: "",
                        link: "https://www.meetup.com/GDG-VR-Warszawa/events/236416308/"
                    },
                ]
        }
        ,
    ]
;

export const Projects = [
    {
        id: "imitation-robotics",
        name: "Imitation Robotics",
        tagline: `
         Programming robots to help them perform human-specific tasks with Reinforcement and Imitation Learning algorithms. Robots are trained in virtual environments
       created in Unity using Imitation Learning from a human motion capture data.`,
        description: `
       Programming robots to help them perform human-specific tasks with Reinforcement and Imitation Learning algorithms. Robots are trained in virtual environments
       created in Unity using Imitation Learning from a human motion capture data. During reinforcement we used a Proximal Policy Optimization to allow robot 
       to come up with most efficient and accurate way of performing a particular task. Later on trained neural network is reinforced by couple of minutes training in a real environment.  
        `,
        role: "CEO, CTO, ML Developer",
        link: "",
        image: humane_robotics,
        logo: "",
        slides: "//www.slideshare.net/slideshow/embed_code/key/I80271EWIgyLF5",
        media: [humane_robotics, mcevr1],
        tags: [Tags.STARTUP, Tags.ML, Tags.UNITY, Tags.PYTHON],
        highlighted: true
    },
    {
        id: "sort-it",
        name: "Polidea Sort-It - VR Game",
        tagline: `
        VR game for HTC Vive and Windows mixed reality designed and built exclusively for MCE 2018 conference.
        `,
        description: `
       During my time in Polidea, with a close collaboration with NoMagic.ai—that built a software platform controlling the robot—and Encon-Koester, 
       exclusively for MCE 2018, we developed the VR industrial training inspired game, 
       where the virtual actions of the human player will be followed by the real-life robot player.
        `,
        role: "Product Owner, Unity Developer",
        link: "",
        image: mcevr,
        media: [mcevr, mcevr1],
        logo: "",
        tags: [Tags.UNITY, Tags.VR],
        highlighted: true,
    },
    {
        id: "polidea-smartshop",
        name: "Polidea Smartshop",
        tagline: `
         Smartshop an Augmented Reality app that I have developed in Polidea build for ARKit-enabled iOS devices. 
         `,
        description: `
        Smartshop is an Augmented Reality app that I have developed in Polidea. 
        We wanted to not only discuss the vast potential of AR in the retail industry but actually, demonstrate it! 
        Smartshop gives an idea of how AR might be integrated into an existing shopping space. It was designed and optimized for iOS devices and integrated with ARKit.
       `,
        role: "Product Owner, Project Manager, Unity Developer",
        ios: "https://itunes.apple.com/us/app/polidea-smartshop/id1340348804",
        image: smarthop,
        media: [smarthop, smarthop1],
        logo: "",
        tags: [Tags.UNITY, Tags.AR],
        video: "ljaSIrutgx4",
        highlighted: true
    },
    {
        id: "polidea-webvr",
        name: "Polidea WebVR Experience",
        tagline: `
         WebVR experiment done with Aframe, WebVR and React, where you can influence your surrounding—change sounds, weather conditions and even day into night.  
         `,
        description: `
        WebVR experiment I've developed in Polidea. You can influence your surrounding—change sounds, weather conditions and even day into night. 
        Select a disc from the menu on the left and put it on a proper stone symbol. This experiment can be run on any mobile and desktop device.
        Technologies used: AFrame, Three.js, React
       `,
        role: "Product Owner, Project Manager, Web Developer",
        link: "https://polideaplayground.github.io/WebVRExperience/",
        image: webvr,
        media: [webvr1, webvr2],
        logo: "",
        tags: [Tags.VR, Tags.WEB],
        highlighted: false
    },
    {
        id: "gripit",
        name: "Gripit",
        tagline: `
        App for climbers and climbing gyms. Finding nearby climbing gyms, tracking ascents and sharing custom problems with friends was never easier.
        Stay motivated by participating in an official ranking list of your climbing gym and compete with others.
        `,
        description: `
        App for climbers and climbing gyms. Finding nearby climbing gyms, tracking ascents and sharing custom problems with friends was never easier.
        Stay motivated by participating in an official ranking list of your climbing gym and compete with others.
        `,
        role: "CEO, Product Owner, Mobile & Backend Developer",
        android: "https://play.google.com/store/apps/details?id=com.gripit.climber&hl=en&rdid=com.gripit.climber",
        image: gripit,
        media: [gripit1, gripit2, gripit3],
        logo: "",
        tags: [Tags.ANDROID, Tags.IOS, Tags.STARTUP, Tags.PYTHON],
        highlighted: true
    },
    {
        id: "velocicaptor",
        name: "VelociCaptor",
        tagline: `
        I've designed an IoT sensor bracelet, which was able to analyse the proper technique of training sport.
        Bracelet was supported by Android app with a neural network trained it to recognize basic boxing punches, like straight, hook and uppercut
        `,
        description: `Self-founded project, in which I've experimented with human movement analysis. 
        Our goal was to build a sensor suit, which would be able to analyse the proper technique of training sport.
        Before running out of money, we managed to develop our own custom IoT bracelet and trained it to recognize basic boxing punches, like straight, hook and uppercut.`,
        role: "Founder, Product Owner, Mobile & ML Developer",
        // link: "https://play.google.com/store/apps/details?id=com.foodsapp.eat",
        image: velocicaptor,
        media: [velocicaptor],
        logo: "",
        tags: [Tags.ANDROID, Tags.ML, Tags.IOT, Tags.STARTUP],
        highlighted: false
    },
    {
        id: "foodsapp",
        name: "Foodsapp",
        description: `App for a food delivery. In this project, I've advised on a general system architecture, including PayU payment integration. 
        Besides, I've coded Android app for customer and partners.`,
        role: "Co-founder, Tech Advisor, Mobile Developer",
        image: foodsapp,
        media: [foodsapp],
        android: "https://play.google.com/store/apps/details?id=com.foodsapp.eat",
        logo: "",
        tags: [Tags.ANDROID, Tags.STARTUP],
        highlighted: false
    },
];

export function getRecentBlogPosts() {
    let requestUrl = "https://vrational.com/feed.xml";

    return parser.parseURL(requestUrl);
}


// WEBPACK FOOTER //
// ./src/database/dictionary.js